import { render, staticRenderFns } from "./iamExam.vue?vue&type=template&id=0e8ba594&scoped=true&"
import script from "./iamExam.vue?vue&type=script&lang=js&"
export * from "./iamExam.vue?vue&type=script&lang=js&"
import style0 from "./iamExam.vue?vue&type=style&index=0&id=0e8ba594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ba594",
  null
  
)

export default component.exports